// src/screens/home/HomeScreen.js
// 41차: 비로그인 로그인 유도 배너 추가
// 42차: 홈 섹션 순서 개인화 (로그인 유저: 내 예약/추천 최상단)
//       자동 슬라이딩 시즌 이벤트 배너 1개만 적용 (나머지 타이머 제거)
// 44차: console 제거 / LoadingOverlay 통일
//       allProducts 페이지네이션 — 초기 20개 로드 + 섹션별 "더보기" 버튼
//       (getAllProducts에 limit 파라미터 지원 필요 — productService 참고)
// 70차: BOOST 플랜 매장이 등록한 "PICK 테마"를 시즌 이벤트 배너 바로 아래에
//       별도 섹션으로 노출 (StoreAdminScreen에서 등록 → EventsScreen 'PICK' 탭에
//       이어 홈 화면까지 노출 지면 확장). 광고성 콘텐츠임을 알 수 있도록
//       골드 테두리 + "PICK" 배지로 다른 추천 섹션과 시각적으로 구분.
// 72차: 디자인 시스템 개편 — 섹션 헤더 이모지 → Ionicons, 히어로 CTA를 GradientButton으로,
//       카드/배너 radius를 RADIUS 토큰으로 통일(RADIUS.md/lg)
// 74차: 남아있던 서비스명 "RoomEscape" 표기 → "UNLOCK"으로 통일
// 74차: 푸터 "이용약관/개인정보처리방침/문의"가 onPress 없는 <Text>라 눌러도 반응이
//       없던 죽은 링크였음 — Terms/Privacy 화면 및 WriteInquiry(app)로 연결
// 74차: 영업용 데모 매장 노출 필터 롤백 → 재도입 — 고객 계정(demo@naver.com)에게 실제
//       고객 화면이 어떻게 보이는지 시연하기 위해 getAllProducts/getTemporaryProducts에
//       {uid} 전달, stores.visibleToUid와 일치할 때만 데모 매장이 보이도록 함
// 74차: 히어로 카드에 검색 진입점 추가 — 기존엔 테마 검색이 "예약" 탭 안에서만 가능했음.
//       입력 후 제출하면 검색어를 들고 예약 탭으로 이동(BookingScreen.js route.params.initialSearch)
// 74차: 섹션 정리 — "새로 문 연 방탈출"(모집 지수와 무관하게 매물이 적어 자주 비어보임),
//       "같이 탈출할 팀원 모집 중"(신규 크루 탭/모집 탭과 중복), BOOST PICK 섹션(PICK이
//       예약 탭 기본화면이 되어 중복) 3개 제거 — RecruitCard/BoostPickCard 컴포넌트 및
//       관련 fetch(getRecruits/getActiveBoostStoreEvents)도 이제 안 쓰여서 함께 제거
// 75차: "이달의 인기 테마"/"리뷰 검증 테마"/"고수만 도전하는 난이도" 세 섹션의 라벨과
//       실제 로직이 서로 어긋나 있던 버그 수정(지난달 예약수 집계가 실제로는 없었고
//       전부 평점/리뷰개수 정렬이었음) — 서버 집계(functions/index.js의
//       scheduledMonthlyPopularStats, stats/monthlyPopular)를 실제로 읽어오도록 교체.
//       "Top 5"였던 인기 테마 섹션도 이제 진짜 상위 5개만 자름(기존엔 20개까지 페이지네이션).

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, FlatList, TouchableOpacity,
  StyleSheet, RefreshControl, Dimensions,
} from 'react-native';
// 78차 37차: 테마 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';

import { getAllProducts, getTemporaryProducts, normalizeProduct } from '../../services/productService';
import { getMyReservations, getMonthlyPopularStats } from '../../services/reservationService';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton } from '../../components/common/Buttons';
import { MenuStoreIcon, MenuReservationIcon, PeopleIcon, MenuReviewIcon, RewardIcon, IconLabel, DifficultyGaugeDots, HalloweenBadgeIcon, StarIcon, ParticipantAcceptIcon, TrophyIcon, EmptyStoresIcon, CancelIcon } from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { COLORS, RADIUS, FONTS } from '../../constants/theme';
import { splitGenres, getSeatingTypeLabel } from '../../constants';
import { Ionicons } from '@expo/vector-icons';
import * as Sentry from '@sentry/react-native';
import { todayStr, isConfirmedMinorBirth } from '../../utils/dateUtils';

const { width } = Dimensions.get('window');
const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const SURFACE    = COLORS.surface;
const SURFACE2   = COLORS.surface2;
const BORDER     = COLORS.border;
const TEXT       = COLORS.text;
const TEXT_SEC   = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const ORANGE     = COLORS.orange;
const TEAL       = COLORS.teal;
const RED        = COLORS.red;
const BLUE       = COLORS.blue;

// 섹션별 초기 노출 개수 — 스크롤 없이 보이는 카드 수
const INITIAL_LIMIT = 8;

// 79차: [버그 수정] new Date(endDate)(UTC 자정 파싱) vs new Date()(로컬/KST 현재시각)를
// 그대로 빼서, 종료일 당일 새벽(자정~오전9시 KST) 몇 시간 동안 하루 밀린 D-Day가 표시될
// 수 있었음(SuperAdminScreen.js의 dDayLabel과 동일한 UTC-vs-로컬 혼동, 전수 정독으로 발견).
// 둘 다 순수 날짜 문자열이므로 Date.UTC로 동일하게 파싱해 시간대 영향을 없앰.
const getDDay = (endDate) => {
  if (!endDate) return null;
  const [ey, em, ed] = endDate.split('-').map(Number);
  const [ty, tm, td] = todayStr().split('-').map(Number);
  const diff = Math.round((Date.UTC(ey, em - 1, ed) - Date.UTC(ty, tm - 1, td)) / 86400000);
  if (diff < 0) return '종료';
  if (diff === 0) return 'D-DAY';
  return `D-${diff}`;
};

// 78차: 홈 테마카드가 난이도를 텍스트 라벨("🔓 쉬움")로, 예약 탭 테마카드는 원형 도트로
// 표시해 같은 정보가 화면마다 다르게 보인다는 신고 — 예약 탭(BookingScreen.js의 StarRow)과
// 동일한 도트 표기로 통일.
// 78차 63차: 이때 매핑을 잘못 베껴와 easy:1~expert:5(3 누락, 5단계)로 만들어져 있었음 —
// 실제 4단계(easy/normal/hard/expert) 체계인 Icons.js의 DifficultyGaugeDots로 교체.
const DifficultyDots = ({ difficulty, size = 9 }) => (
  <DifficultyGaugeDots difficulty={difficulty} size={size} gap={2} color={COLORS.goldLight} mutedColor="#333" />
);

// ─── 테마 카드 ───────────────────────────────────────────────
const HomeCard = ({ product, onPress, showDday, cardWidth, accentBorder }) => {
  const p = normalizeProduct(product);
  const isShow = p.bookingFormat === 'show';
  const dday = showDday ? getDDay(product.operationEnd) : null;
  const isUrgent = dday && !['종료', 'D-DAY'].includes(dday) && parseInt(dday.replace('D-', '')) <= 7;
  return (
    <TouchableOpacity
      style={[card.wrap, cardWidth && { width: cardWidth }, accentBorder && { borderColor: accentBorder }]}
      onPress={() => onPress(p)}
      activeOpacity={0.85}
    >
      <View style={card.imgWrap}>
        {p.thumbnailUrl
          ? <Image source={{ uri: p.thumbnailUrl }} style={card.img} />
          : <View style={[card.img, card.placeholder]}><LogoMark size={32} /></View>}
        {dday && (
          <View style={[card.ddayBadge, isUrgent && card.ddayUrgent]}>
            <Text style={card.ddayText}>{dday}</Text>
          </View>
        )}
        {/* 80차 후속: [버그 수정] 배지가 뒤에 깔린 테마 이미지 색상에 따라(특히 밝은
            사진) 배지 색이 묻혀 잘 안 보인다는 신고 — 이미지 밝기와 무관하게 항상
            읽히도록 배지 뒤에 어두운 그라디언트 스크림 추가(넷플릭스류 카드에서 흔히
            쓰는 패턴). pointerEvents="none"으로 카드 터치에는 영향 없음. */}
        <LinearGradient
          colors={['transparent', 'rgba(0,0,0,0.75)']}
          style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 46 }}
          pointerEvents="none"
        />
        {/* 80차 후속: [정책 확정] 배지 순서 — ①형식(방탈출/체험형, 필수) → ②19금 → ③장르 */}
        <View style={{ position: 'absolute', bottom: 8, left: 8, flexDirection: 'row', gap: 4 }}>
          {isShow ? (
            <View style={card.showBadge}><Text style={card.showBadgeText}>체험형</Text></View>
          ) : (
            <View style={card.roomBadge}><Text style={card.roomBadgeText}>방탈출</Text></View>
          )}
          {/* 80차 후속: 체험형 전용 — 단독 대관/합석 뱃지 */}
          {isShow && (
            <View style={card.seatBadge}><Text style={card.seatBadgeText}>{getSeatingTypeLabel(p.seatingType)}</Text></View>
          )}
          {p.isAdultOnly && (
            <View style={card.adultBadge}><Text style={card.adultBadgeText}>19금</Text></View>
          )}
          {p.genres?.[0] && (
            <View style={card.genreBadge}>
              <Text style={card.genreBadgeText}>{p.genres[0]}</Text>
            </View>
          )}
        </View>
      </View>
      <View style={card.body}>
        <Text style={card.title} numberOfLines={1}>{p.name}</Text>
        <IconLabel Icon={MenuStoreIcon} size={11} color={TEXT_MUTED} textStyle={card.branch} numberOfLines={1}>{p.storeName}</IconLabel>
        <View style={card.meta}>
          <View style={card.ratingRow}>
            <IconLabel Icon={StarIcon} size={12} color={card.rating.color} textStyle={card.rating}>{(product.rating || 0).toFixed(1)}</IconLabel>
            <Text style={card.reviewCount}>({product.reviewCount || 0})</Text>
          </View>
          {/* 80차 후속: 체험형 공연은 탈출 난이도 개념이 없어 표시하지 않음 */}
          {!isShow && product.difficulty && <DifficultyDots difficulty={product.difficulty} />}
        </View>
        {/* 80차 후속: 체험형은 "1인당" 단가 표기 */}
        {isShow
          ? p.pricePerPerson > 0 && <Text style={card.price}>{Number(p.pricePerPerson).toLocaleString()}원 (1인당)</Text>
          : p.price != null && <Text style={card.price}>{Number(p.price).toLocaleString()}원~</Text>}
      </View>
    </TouchableOpacity>
  );
};

const card = StyleSheet.create({
  wrap:           { width: 185, marginRight: 14, backgroundColor: SURFACE, borderRadius: RADIUS.md, overflow: 'hidden', borderWidth: 1, borderColor: BORDER, shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.4, shadowRadius: 8, elevation: 6 },
  imgWrap:        { width: '100%', height: 120, position: 'relative' },
  img:            { width: '100%', height: '100%', backgroundColor: '#1a1a2e' },
  placeholder:    { justifyContent: 'center', alignItems: 'center' },
  ddayBadge:      { position: 'absolute', top: 8, right: 8, backgroundColor: 'rgba(255,107,53,0.92)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 3 },
  ddayUrgent:     { backgroundColor: 'rgba(220,38,38,0.95)' },
  ddayText:       { color: TEXT, fontSize: 10, fontWeight: '700' },
  // 80차 후속: 절대위치는 이제 부모 배지 행(View)이 담당 — 이 스타일은 시각적 요소만
  genreBadge:     { backgroundColor: 'rgba(212,168,67,0.2)', borderWidth: 1, borderColor: 'rgba(212,168,67,0.35)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 2 },
  genreBadgeText: { color: GOLD, fontSize: 10, fontWeight: '600' },
  // 80차 후속: genreBadgeText와 fontWeight를 통일(600) — 색만 다르게
  showBadge:      { backgroundColor: 'rgba(143,211,224,0.18)', borderWidth: 1, borderColor: 'rgba(143,211,224,0.4)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 2 },
  showBadgeText:  { color: '#8FD3E0', fontSize: 10, fontWeight: '600' },
  roomBadge:      { backgroundColor: COLORS.teal+'2E', borderWidth: 1, borderColor: COLORS.teal+'66', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 2 },
  roomBadgeText:  { color: COLORS.teal, fontSize: 10, fontWeight: '600' },
  seatBadge:      { backgroundColor: 'rgba(167,139,250,0.18)', borderWidth: 1, borderColor: 'rgba(167,139,250,0.4)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 2 },
  seatBadgeText:  { color: '#a78bfa', fontSize: 10, fontWeight: '600' },
  adultBadge:     { backgroundColor: COLORS.dangerBg, borderWidth: 1, borderColor: COLORS.danger+'66', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 2 },
  adultBadgeText: { color: COLORS.danger, fontSize: 10, fontWeight: '600' },
  body:           { padding: 12, gap: 3 },
  title:          { color: TEXT, fontSize: 13, fontWeight: '700' },
  branch:         { color: TEXT_MUTED, fontSize: 11 },
  meta:           { flexDirection: 'row', justifyContent: 'space-between', marginTop: 2 },
  ratingRow:      { flexDirection: 'row', alignItems: 'center', gap: 3 },
  rating:         { color: GOLD, fontSize: 11, fontWeight: '700' },
  reviewCount:    { color: TEXT_MUTED, fontSize: 10 },
  price:          { color: GOLD, fontSize: 12, fontWeight: '700', marginTop: 6, paddingTop: 8, borderTopWidth: 1, borderTopColor: BORDER },
});

// ─── 스켈레톤 ────────────────────────────────────────────────
const SkeletonCard = () => (
  <View style={{ width: 185, marginRight: 14, backgroundColor: SURFACE, borderRadius: RADIUS.md, overflow: 'hidden', borderWidth: 1, borderColor: BORDER }}>
    <View style={{ width: '100%', height: 120, backgroundColor: '#1a1a2e' }} />
    <View style={{ padding: 12, gap: 8 }}>
      {[80, 55, 40].map((w, i) => (
        <View key={i} style={{ height: 10, borderRadius: 5, backgroundColor: '#1e1e30', width: `${w}%` }} />
      ))}
    </View>
  </View>
);

// ─── 섹션 헤더 ───────────────────────────────────────────────
// 72차: icon prop을 이모지 문자 → Ionicons 이름으로 변경(디자인 시스템 개편)
// 80차 계속: "이달의 인기 테마" 전체보기가 RegionalRankingScreen(지역별 랭킹)으로 이어지는
// 유일한 진입로인데, 다른 섹션들과 똑같은 얇은 텍스트 링크라 눈에 잘 안 띄었음 — 이 섹션
// 하나만 moreLabel/moreIcon/emphasis로 살짝 강조. 나머지 섹션은 prop을 안 넘겨 기존과 동일.
const SectionHeader = ({ icon, title, accentColor, onMore, subtitle, moreLabel = '전체보기', moreIcon: MoreIcon, emphasis = false }) => (
  <View style={sh.wrap}>
    <View style={{ flex: 1 }}>
      <View style={sh.left}>
        <Ionicons name={icon} size={19} color={accentColor || GOLD} />
        <Text style={[sh.title, { color: accentColor || GOLD }]}>{title}</Text>
      </View>
      {subtitle && <Text style={sh.subtitle}>{subtitle}</Text>}
    </View>
    {onMore && (
      <TouchableOpacity onPress={onMore} style={[sh.moreBtn, emphasis && sh.moreBtnEmphasis]}>
        {MoreIcon && <MoreIcon size={12} color={GOLD} />}
        <Text style={[sh.moreText, emphasis && sh.moreTextEmphasis]}>{moreLabel}</Text>
      </TouchableOpacity>
    )}
  </View>
);
const sh = StyleSheet.create({
  wrap:     { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14, paddingHorizontal: 16 },
  left:     { flexDirection: 'row', alignItems: 'center', gap: 8 },
  title:    { fontSize: 16, fontFamily: FONTS.displaySemi },
  subtitle: { color: TEXT_MUTED, fontSize: 11, marginTop: 3, marginLeft: 27 },
  moreBtn:  { flexDirection: 'row', alignItems: 'center', gap: 4, paddingHorizontal: 10, paddingVertical: 5, borderRadius: RADIUS.sm, borderWidth: 1, borderColor: BORDER, marginTop: 2 },
  moreText: { fontSize: 11, color: GOLD, fontWeight: '600' },
  moreBtnEmphasis:  { backgroundColor: GOLD + '1c', borderColor: GOLD + '70' },
  moreTextEmphasis: { fontSize: 12, fontWeight: '800' },
});

// ─── 시즌 이벤트 배너 카드 ───────────────────────────────────
const EventBannerCard = ({ product, onPress, cardWidth }) => {
  const p = normalizeProduct(product);
  const dday = getDDay(product.operationEnd);
  const isUrgent = dday && !['종료', 'D-DAY'].includes(dday) && parseInt(dday.replace('D-', '')) <= 7;
  return (
    <TouchableOpacity style={[eb.wrap, { width: cardWidth }]} onPress={() => onPress(p)} activeOpacity={0.88}>
      <View style={eb.imgWrap}>
        {p.thumbnailUrl
          ? <Image source={{ uri: p.thumbnailUrl }} style={eb.img} />
          : <View style={[eb.img, eb.placeholder]}><HalloweenBadgeIcon size={44} /></View>}
        <View style={eb.overlay} />
        {dday && (
          <View style={[eb.ddayBadge, isUrgent && eb.ddayUrgent]}>
            <Text style={eb.ddayText}>{dday}</Text>
          </View>
        )}
      </View>
      <View style={eb.info}>
        <View style={{ flexDirection: 'row', gap: 6, marginBottom: 6 }}>
          <View style={eb.eventTag}><Text style={eb.eventTagText}>🎉 시즌 이벤트</Text></View>
          {p.genres?.[0] && <View style={eb.genreTag}><Text style={eb.genreTagText}>{p.genres[0]}</Text></View>}
        </View>
        <Text style={eb.title} numberOfLines={1}>{p.name}</Text>
        <IconLabel Icon={MenuStoreIcon} size={11} color={TEXT_MUTED} textStyle={eb.branch} numberOfLines={1}>{p.storeName}</IconLabel>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
            <IconLabel Icon={StarIcon} size={12} color={eb.rating.color} textStyle={eb.rating}>{(product.rating || 0).toFixed(1)}</IconLabel>
            <Text style={eb.reviewCount}>({product.reviewCount || 0})</Text>
          </View>
          {p.price != null && <Text style={eb.price}>{Number(p.price).toLocaleString()}원~</Text>}
        </View>
      </View>
    </TouchableOpacity>
  );
};
const eb = StyleSheet.create({
  wrap:        { marginRight: 14, backgroundColor: SURFACE, borderRadius: RADIUS.md, overflow: 'hidden', borderWidth: 1.5, borderColor: 'rgba(255,107,53,0.25)' },
  imgWrap:     { width: '100%', height: 160, position: 'relative' },
  img:         { width: '100%', height: '100%', backgroundColor: '#1a1a2e' },
  placeholder: { justifyContent: 'center', alignItems: 'center' },
  overlay:     { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.25)' },
  ddayBadge:   { position: 'absolute', top: 10, right: 10, backgroundColor: 'rgba(255,107,53,0.95)', borderRadius: 5, paddingHorizontal: 9, paddingVertical: 4 },
  ddayUrgent:  { backgroundColor: 'rgba(220,38,38,0.97)' },
  ddayText:    { color: '#fff', fontSize: 11, fontWeight: '800' },
  info:        { padding: 14 },
  eventTag:    { backgroundColor: 'rgba(255,107,53,0.18)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 3, borderWidth: 1, borderColor: 'rgba(255,107,53,0.35)' },
  eventTagText:{ color: ORANGE, fontSize: 10, fontWeight: '700' },
  genreTag:    { backgroundColor: 'rgba(212,168,67,0.15)', borderRadius: 4, paddingHorizontal: 7, paddingVertical: 3, borderWidth: 1, borderColor: 'rgba(212,168,67,0.3)' },
  genreTagText:{ color: GOLD, fontSize: 10, fontWeight: '600' },
  title:       { color: TEXT, fontSize: 15, fontWeight: '800', marginBottom: 3 },
  branch:      { color: TEXT_MUTED, fontSize: 12 },
  rating:      { color: GOLD, fontSize: 12, fontWeight: '700' },
  reviewCount: { color: TEXT_MUTED, fontSize: 11 },
  price:       { color: GOLD, fontSize: 13, fontWeight: '800' },
});

// ─── 슬라이드 도트 인디케이터 ────────────────────────────────
const DotIndicator = ({ total, current }) => (
  <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 5, marginTop: 10 }}>
    {Array.from({ length: total }, (_, i) => (
      <View key={i} style={{ width: i === current ? 16 : 5, height: 5, borderRadius: 3, backgroundColor: i === current ? GOLD : 'rgba(212,168,67,0.25)' }} />
    ))}
  </View>
);

// ─── 다가오는 예약 카드 ──────────────────────────────────────
const UpcomingReservationCard = ({ reservation, onPress }) => {
  // 78차 69차: toISOString()은 UTC 기준이라 새벽 0~9시(KST)엔 "오늘"이 하루 밀려 보이던
  // 버그 — 로컬 날짜로 비교
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const isToday = reservation.date === today;
  // 79차: [버그 수정] 위 "오늘" 판정은 이미 로컬 날짜로 정확한데, 그 아래 D-Day 숫자는
  // `new Date(reservation.date) - new Date()`로 UTC-vs-로컬 혼동이 그대로 남아있었음
  // (형제 로직 중 한쪽만 고침 — 전수 정독으로 발견). getDDay()와 동일한 Date.UTC 기준으로 통일.
  const [ry, rm, rd] = reservation.date.split('-').map(Number);
  const [ty, tm, td] = today.split('-').map(Number);
  const dDayNum = Math.round((Date.UTC(ry, rm - 1, rd) - Date.UTC(ty, tm - 1, td)) / 86400000);
  return (
    <TouchableOpacity style={ur.wrap} onPress={onPress} activeOpacity={0.85}>
      <View style={ur.badge}>
        <Text style={ur.badgeText}>{isToday ? '오늘' : `D-${dDayNum}`}</Text>
      </View>
      <Text style={ur.name} numberOfLines={1}>{reservation.productName || reservation.themeName || '테마'}</Text>
      <IconLabel Icon={MenuReservationIcon} size={11} color={TEXT_MUTED} textStyle={ur.info}>{reservation.date} {reservation.time || ''}</IconLabel>
      {reservation.branchName && <IconLabel Icon={MenuStoreIcon} size={11} color={TEXT_MUTED} textStyle={ur.branch}>{reservation.branchName}</IconLabel>}
    </TouchableOpacity>
  );
};
const ur = StyleSheet.create({
  wrap:      { width: 200, marginRight: 14, backgroundColor: SURFACE2, borderRadius: RADIUS.md, padding: 14, borderWidth: 1.5, borderColor: GOLD + '40' },
  badge:     { alignSelf: 'flex-start', backgroundColor: GOLD + '25', borderRadius: 4, paddingHorizontal: 8, paddingVertical: 3, marginBottom: 8, borderWidth: 1, borderColor: GOLD + '50' },
  badgeText: { color: GOLD, fontSize: 11, fontWeight: '800' },
  name:      { color: TEXT, fontSize: 14, fontWeight: '800', marginBottom: 4 },
  info:      { color: TEXT_SEC, fontSize: 12, marginBottom: 2 },
  branch:    { color: TEXT_MUTED, fontSize: 11, marginBottom: 8 },
});

// ─── 난이도 추천 섹션 ────────────────────────────────────────
const RecommendSection = ({ allProducts, userRecords, navigation }) => {
  // 71차: 계산 전체를 useMemo로 묶음 — 이전엔 Math.random()이 포함된 필터가
  // 관련 없는 상태 변경으로 인한 리렌더마다 재실행돼 추천 목록이 매번 흔들렸음
  // (55차에 고친 PICK 섹션과 동일한 종류의 문제가 이 섹션엔 남아있었음)
  const { list: recommended, label: recommendedLabel, color: diffColor, rate: successRate } = useMemo(() => {
    const empty = { list: [], label: '', color: GOLD, rate: 0 };
    if (!userRecords?.length) return empty;
    const completedRecords = userRecords.filter(r => !r.cancelled && r.date);
    if (!completedRecords.length) return empty;

    // 79차: [버그 수정] r.success !== null은 아직 결과가 안 나온(예정된/미기록) 예약도
    // 분모에 포함시켰음 — 결과 미기록 시 r.success는 null이 아니라 undefined라
    // undefined !== null이 true가 되어 그대로 통과됨(전수 정독으로 발견). 예: 과거 5건
    // (성공4/실패1, 실제 성공률 80%)에 예정된 예약 2건이 있으면 totalCount=7로 잘못
    // 계산돼 성공률이 57%로 실제보다 훨씬 낮게 나와, 실력에 안 맞는 낮은 난이도만
    // 추천될 수 있었음. MyPageScreen.js(78차69차)의 형제 로직이 이미 쓰고 있는
    // "명시적으로 결과가 기록된 것만" 기준으로 통일.
    const successCount = completedRecords.filter(r => r.success === true).length;
    const totalCount   = completedRecords.filter(r => r.success === true || r.success === false).length;
    const rate         = totalCount > 0 ? successCount / totalCount : 0.5;

    // 79차: [버그 수정] BookingScreen.js는 78차45차에 "공포/추리"처럼 슬래시로 이어붙은
    // 다중 장르 값을 splitGenres로 쪼개 매칭하도록 이미 고쳤는데, 이 형제 로직은 그대로
    // 단일 문자열 완전일치만 하고 있었음(홈/예약 탭 전수 재정독 fork로 발견) — 다중
    // 장르 테마를 많이 완료한 유저는 genreCount가 흩어져 선호 장르가 잘못 계산되고,
    // favoriteGenre가 맞게 나와도 다중 장르 테마는 p.genre===favoriteGenre가 항상
    // 거짓이라 추천에서 빠져 사실상 랜덤에 가깝게 저하됐음.
    const genreCount = {};
    completedRecords.forEach(r => {
      splitGenres(r.genre).forEach(g => { genreCount[g] = (genreCount[g] || 0) + 1; });
    });
    const favoriteGenre = Object.entries(genreCount).sort((a, b) => b[1] - a[1])[0]?.[0];

    const playedIds = new Set(completedRecords.map(r => r.productId).filter(Boolean));

    const recommendedDiff =
      rate >= 0.7 ? ['hard', 'expert'] :
      rate >= 0.4 ? ['normal', 'hard'] :
      ['easy', 'normal'];

    const label = rate >= 0.7 ? '고난이도' : rate >= 0.4 ? '중급' : '입문';
    const color = rate >= 0.7 ? RED : rate >= 0.4 ? GOLD : '#4ade80';

    // 80차 후속: [버그 수정] 형제 섹션 "고수만 도전하는 난이도"는 체험형을 이미 제외하는데
    // 이 섹션만 놓쳐서, 체험형 테마에 남아있는 과거 difficulty 기본값이 우연히 추천
    // 난이도 구간과 겹치면 난이도 근거 없이 섞여 나올 수 있었음(fork로 발견).
    const list = allProducts
      .filter(p => (p.bookingFormat||'room')!=='show' && recommendedDiff.includes(p.difficulty) && !playedIds.has(p.id) && (!favoriteGenre || splitGenres(p.genre).includes(favoriteGenre) || Math.random() > 0.6))
      .sort((a, b) => (b.rating || 0) - (a.rating || 0))
      .slice(0, INITIAL_LIMIT);

    return { list, label, color, rate };
  }, [allProducts, userRecords]);

  if (!recommended.length) return null;

  return (
    <View style={s.section}>
      <SectionHeader
        icon="locate"
        title="내 실력에 딱 맞는 추천"
        accentColor={diffColor}
        subtitle={`성공률 ${Math.round(successRate * 100)}% 기반 · ${recommendedLabel} 난이도 추천`}
        onMore={() => navigation.navigate('Booking')}
      />
      <FlatList
        data={recommended}
        keyExtractor={i => i.id}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ paddingLeft: 16, paddingRight: 16 }}
        renderItem={({ item }) => (
          <HomeCard product={item} onPress={p => navigation.navigate('ThemeDetail', { product: p })} accentBorder={diffColor + '60'} />
        )}
      />
    </View>
  );
};

// ─── 페이지네이션 가로 리스트 ────────────────────────────────
// full 데이터를 받아 limit까지만 노출, "더 보기" 버튼으로 Booking 이동
const PaginatedHorizontalList = ({ data, loading, showDday = false, onMore, onPressItem }) => {
  const [limit, setLimit] = useState(INITIAL_LIMIT);
  const visible = data.slice(0, limit);
  const hasMore = data.length > limit;

  if (loading) return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingLeft: 16 }}>
      {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
    </ScrollView>
  );
  if (!data.length) return (
    <Text style={{ color: TEXT_MUTED, paddingHorizontal: 16, fontStyle: 'italic' }}>등록된 테마가 없습니다.</Text>
  );

  return (
    <>
      <FlatList
        data={visible}
        keyExtractor={i => i.id}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ paddingLeft: 16, paddingRight: 16 }}
        onEndReached={() => { if (hasMore) setLimit(l => l + INITIAL_LIMIT); }}
        onEndReachedThreshold={0.5}
        renderItem={({ item }) => (
          <HomeCard product={item} onPress={onPressItem} showDday={showDday} />
        )}
        // 리스트 끝에 "더보기" 인라인 카드
        ListFooterComponent={hasMore ? (
          <TouchableOpacity style={pl.moreCard} onPress={onMore} activeOpacity={0.85}>
            <Text style={pl.moreIcon}>›</Text>
            <Text style={pl.moreLabel}>더보기</Text>
          </TouchableOpacity>
        ) : null}
      />
    </>
  );
};
const pl = StyleSheet.create({
  moreCard:  { width: 72, marginRight: 14, backgroundColor: SURFACE, borderRadius: RADIUS.md, borderWidth: 1, borderColor: BORDER, justifyContent: 'center', alignItems: 'center', height: 180 },
  moreIcon:  { color: GOLD, fontSize: 28, fontWeight: '800' },
  moreLabel: { color: GOLD, fontSize: 11, fontWeight: '700', marginTop: 4 },
});

// ─── 메인 ────────────────────────────────────────────────────
export default function HomeScreen({ navigation, route }) {
  const { displayName, isLoggedIn, user, profile } = useAuth();

  const [allProducts,       setAllProducts]       = useState([]);
  const [seasonalProducts,  setSeasonalProducts]  = useState([]);
  const [userReservations,  setUserReservations]  = useState([]);
  const [popularCounts,     setPopularCounts]     = useState({}); // 75차: 지난달 예약수 집계(productId→count)
  const [loading,           setLoading]           = useState(true);
  const [refreshing,        setRefreshing]        = useState(false);
  // 80차 계속: 첫 진입 온보딩 — RegisterScreen.js/SocialOnboardingScreen.js가 가입 직후
  // Home으로 이동시킬 때만 justSignedUp 파라미터를 실어보냄(일반 로그인은 안 실림) —
  // 마운트 시점 값으로 한 번만 고정해, 이후 탭을 오가도 다시 나타나지 않게 함.
  const [showSignupNudge, setShowSignupNudge] = useState(() => !!route?.params?.justSignedUp);

  // 시즌 이벤트 슬라이드
  const [eventIdx, setEventIdx] = useState(0);
  const eventRef    = useRef(null);
  const eventIdxRef = useRef(0);
  // 79차: 탭을 빠르게 오가면 이전 포커스의 load()가 늦게 응답해 최신 데이터를 오래된
  // 것으로 덮어쓸 수 있었음(MyReviewsScreen.js가 74차에 막아둔 것과 동일 위험) —
  // activeRef로 이전 포커스 세션의 setState만 무시.
  const activeRef = useRef(true);

  const WIDE_CARD_W = width - 64;
  const CARD_GAP    = 14;

  // ── 데이터 로드 ──────────────────────────────────────────
  // 78차 73차/78차 37차: 로그아웃(로그인→게스트 전환) 시 하단 탭 네비게이터 전체가 key
  // 변경으로 리마운트되면서 이 화면도 새로 마운트되는데, 그 순간 로딩이 계속 멈춰있는
  // 것처럼 보인다는 신고가 반복됨. 78차37차엔 "Firestore 네트워크 채널이 signOut
  // 타이밍에 고아 상태로 남는다"는 가설로 authService.js의 logout()에 네트워크 재시작을
  // 추가했으나(그 자체는 유지 — 무해하고 다른 네트워크 정체 상황엔 여전히 도움), 실기기
  // 재현으로 실제 원인은 따로 있었음이 드러남: 이 리마운트 직후 `useFocusEffect`가
  // 로그인→게스트 전환 시에는(반대 방향인 게스트→로그인 전환에서는 정상 발동) 발동하지
  // 않아 load() 자체가 한 번도 호출되지 않는 경우가 있었음(react-navigation의 포커스
  // 판정이 이 특정 remount 타이밍에 새 네비게이터의 초기 포커스 상태를 아직 못 잡는
  // 것으로 추정). 아래 mount 전용 useEffect로 이 화면이 마운트되면 포커스 이벤트와
  // 무관하게 최초 1회는 반드시 load()가 실행되도록 보강 — 근본 수정.
  const load = useCallback(async () => {
    try {
      const timeout = (ms) => new Promise((_, reject) => setTimeout(() => reject(new Error('home_load_timeout')), ms));
      // 80차 후속: 확인된 미성년자에게 19금 테마 목록 노출 차단(isVisibleToViewer 참고)
      const isMinor = isConfirmedMinorBirth(profile?.birth);
      const [all, seasonal, popularStats] = await Promise.race([
        Promise.all([
          getAllProducts({ uid: user?.uid, isMinor }),       // 전체 로드 (클라이언트 슬라이싱)
          getTemporaryProducts({ uid: user?.uid, isMinor }),
          getMonthlyPopularStats().catch(() => ({ productCounts: {} })),
        ]),
        timeout(10000),
      ]);
      if (!activeRef.current) return;
      setAllProducts(all);
      setSeasonalProducts(seasonal);
      setPopularCounts(popularStats.productCounts || {});

      if (isLoggedIn && user?.uid) {
        getMyReservations(user.uid)
          .then(res => { if (activeRef.current) setUserReservations(res); })
          .catch(() => { if (activeRef.current) setUserReservations([]); });
      } else {
        setUserReservations([]);
      }
    } catch (e) {
      // 78차 32차: 홈 화면 핵심 데이터(전체 테마/시즌 이벤트) 로드 실패가 이제껏 완전
      // 무음이라 재현/진단이 불가능했음 — 다른 화면들과 동일한 Sentry 패턴으로 캡처.
      Sentry.captureException(e, { tags: { flow: 'home_load' } });
    } finally {
      if (activeRef.current) { setLoading(false); setRefreshing(false); }
    }
  // 80차 후속: profile?.birth를 deps에 추가 — user보다 늦게 비동기로 채워지는 profile
  // (이 세션에서 반복된 레이스컨디션 패턴) 값으로 isMinor를 계산하는데, 이게 없으면
  // 최초 로드 시점(profile 아직 null)의 isMinor=false가 그대로 굳어 이후 profile이
  // 채워져도 재조회 없이는 19금 테마가 계속 노출될 수 있었음.
  }, [isLoggedIn, user?.uid, profile?.birth]);

  // 78차 39차: 홈은 하단 탭이라 다른 탭에서 예약/취소 등을 하고 돌아와도 리마운트되지
  // 않아서, 마운트 1회성 useEffect로는 "다가오는 예약" 등이 계속 예전 상태로 보임 —
  // BookingScreen.js/PointHistoryScreen.js와 동일한 이유로 useFocusEffect로 전환.
  // 78차 37차: useFocusEffect가 못 잡는 마운트 케이스(위 주석 참고)를 위한 안전장치 —
  // 마운트 시 한 번은 focus 이벤트와 무관하게 무조건 실행.
  useEffect(() => { load(); }, []);
  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    load();
    return () => { activeRef.current = false; };
  }, [load]));

  // ── 시즌 이벤트 자동 슬라이드 ───────────────────────────
  useEffect(() => {
    if (loading || seasonalProducts.length <= 1) return;
    const timer = setInterval(() => {
      const next = (eventIdxRef.current + 1) % seasonalProducts.length;
      eventIdxRef.current = next;
      setEventIdx(next);
      try { eventRef.current?.scrollToIndex({ index: next, animated: true, viewPosition: 0 }); } catch (_) {}
    }, 3500);
    return () => clearInterval(timer);
  }, [loading, seasonalProducts.length]);

  const onEventScroll = (e) => {
    const idx = Math.round(e.nativeEvent.contentOffset.x / (WIDE_CARD_W + CARD_GAP));
    eventIdxRef.current = idx;
    setEventIdx(idx);
  };

  // ── 섹션 데이터 (클라이언트 슬라이싱) ───────────────────
  // 75차: 세 섹션의 라벨과 실제 로직이 서로 어긋나 있던 버그 수정.
  //  - "이달의 인기 테마 Top 5": 지난달 예약수 집계(popularCounts, stats/monthlyPopular)
  //    기준 상위 5개 — 기존엔 이 자리에 평점 정렬(topRated)이 들어가 있었음.
  //  - "리뷰 검증 테마": 평점 정렬 — 기존엔 이 자리에 리뷰 "개수" 정렬(mostReviewed)이
  //    들어가 있었음(개수≠평점).
  //  - "고수만 도전하는 난이도": 지난달 예약수 집계 중 난이도가 'expert'인 것만 —
  //    기존엔 'hard'까지 섞여 있었고, 정렬 기준도 평점이었음(예약수 아님).
  const popularThemes = [...allProducts]
    .filter(p => (popularCounts[p.id] || 0) > 0)
    .sort((a, b) => (popularCounts[b.id] || 0) - (popularCounts[a.id] || 0))
    .slice(0, 5);

  const reviewVerifiedThemes = [...allProducts]
    .filter(p => (p.reviewCount || 0) > 0)
    .sort((a, b) => (b.rating || 0) - (a.rating || 0))
    .slice(0, 20);

  // 80차 후속: 체험형 공연은 난이도 대신 활동성을 쓰므로("난이도" 필드 자체가 무의미)
  // 혹시 기본값이 'expert'로 남아있어도 이 "고수만 도전" 섹션엔 절대 안 걸리게 제외.
  const expertThemes = [...allProducts]
    .filter(p => p.difficulty === 'expert' && p.bookingFormat !== 'show' && (popularCounts[p.id] || 0) > 0)
    .sort((a, b) => (popularCounts[b.id] || 0) - (popularCounts[a.id] || 0))
    .slice(0, 20);

  // 78차 69차: r.date >= today(날짜만 비교)라서, 매장이 이미 결과를 입력했거나(성공/실패)
  // 시간이 지난 "오늘" 예약도 계속 "다가오는 예약"에 남아있던 버그 — 결과가 입력된 건
  // 무조건 제외, 아니면 예약 시작 시각까지 지나야 제외되도록 수정.
  const nowInstant = new Date();
  const upcomingReservations = userReservations
    .filter(r => !r.cancelled && r.paymentStatus !== 'pending')
    .filter(r => r.success !== true && r.success !== false)
    .filter(r => r.date && new Date(`${r.date}T${r.time || '23:59'}`) > nowInstant)
    .sort((a, b) => (a.date || '').localeCompare(b.date || '') || (a.time || '').localeCompare(b.time || ''))
    .slice(0, 5);

  const goDetail   = (p) => navigation.navigate('ThemeDetail', { product: p });
  const goBooking  = () => navigation.navigate('Booking');
  // 80차: "이달의 인기 테마"의 더보기는 예약 탭(필터/정렬 뷰)이 아니라, 같은 데이터를
  // 더 깊게 보여주는 지역별 인기 테마 랭킹 화면으로 연결
  const goRanking  = () => navigation.navigate('RegionalRanking');

  // ── 시즌 이벤트 렌더 ─────────────────────────────────────
  const renderEventBanners = () => {
    if (loading) return (
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingLeft: 16 }}>
        {[1, 2].map(i => <SkeletonCard key={i} />)}
      </ScrollView>
    );
    if (!seasonalProducts.length) return (
      <View style={s.emptyEvent}>
        <Text style={s.emptyEventText}>현재 진행 중인 시즌 이벤트가 없습니다.</Text>
      </View>
    );
    return (
      <>
        <FlatList
          ref={eventRef}
          data={seasonalProducts}
          keyExtractor={i => i.id}
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ paddingLeft: 16, paddingRight: 16 }}
          snapToInterval={WIDE_CARD_W + CARD_GAP}
          snapToAlignment="start"
          decelerationRate="fast"
          onScroll={onEventScroll}
          scrollEventThrottle={16}
          onScrollToIndexFailed={() => {}}
          renderItem={({ item }) => (
            <EventBannerCard product={item} onPress={goDetail} cardWidth={WIDE_CARD_W} />
          )}
        />
        {seasonalProducts.length > 1 && <DotIndicator total={seasonalProducts.length} current={eventIdx} />}
      </>
    );
  };

  // ── 렌더 ─────────────────────────────────────────────────
  return (
    <View style={s.container}>
      <AppHeader
        rightElement={
          isLoggedIn
            ? <TouchableOpacity onPress={() => navigation.navigate('MyPage')}>
                <Text style={s.greetingText}>👋 {displayName}</Text>
              </TouchableOpacity>
            : undefined
        }
      />

      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={() => { setRefreshing(true); load(); }} tintColor={GOLD} />
        }
      >
        {/* ── 히어로 ──────────────────────────────────────── */}
        <View style={s.hero}>
          <View style={s.heroLeft}>
            <IconLabel Icon={LogoMark} size={s.heroEyebrow.fontSize || 13} color={s.heroEyebrow.color} textStyle={s.heroEyebrow}>방탈출 예약</IconLabel>
            <Text style={s.heroTitle}>
              {isLoggedIn && displayName
                ? <><Text style={s.heroHighlight}>{displayName}</Text>님, 오늘도{'\n'}탈출에 도전하세요 🔥</>
                : <><Text style={s.heroHighlight}>UNLOCK</Text>에서{'\n'}탈출의 짜릿함을</>
              }
            </Text>
          </View>
          <View style={s.heroStats}>
            <View style={s.heroStat}>
              <Text style={s.heroStatValue}>{loading ? '-' : allProducts.length}</Text>
              <Text style={s.heroStatLabel}>테마</Text>
            </View>
            <View style={s.heroStatDivider} />
            <View style={s.heroStat}>
              {/* 오늘 웹페이지 개선 요청으로 수정: 초기 단계엔 리뷰 절대 개수(작은 값)가
                  오히려 "아직 안 써본 앱"처럼 보이게 만들 수 있어서, 같은 데이터로
                  계산 가능하면서 표본이 적어도 부정적으로 안 읽히는 평균 평점으로 교체
                  (SuperAdminStoresScreen.js의 avgRating 계산과 동일한 가중평균 방식). */}
              <Text style={s.heroStatValue}>
                {(() => {
                  if (loading) return '-';
                  const totalReviews = allProducts.reduce((sum, p) => sum + (p.reviewCount || 0), 0);
                  if (totalReviews === 0) return '-';
                  const avg = allProducts.reduce((sum, p) => sum + (p.rating || 0) * (p.reviewCount || 0), 0) / totalReviews;
                  return avg.toFixed(1);
                })()}
              </Text>
              <Text style={s.heroStatLabel}>평균 평점</Text>
            </View>
          </View>
          <View style={s.heroBtnRow}>
            <GradientButton label="예약하기 →" onPress={goBooking} style={{ flex: 3 }} />
            <SecondaryButton
              label="PICK·공지"
              onPress={() => navigation.navigate('Events', { showBack: true })}
              style={s.heroBtnSecondary}
              textStyle={s.heroBtnSecondaryText}
            />
          </View>
        </View>

        {/* ── 첫 진입 온보딩(가입 직후 1회) ────────────────── */}
        {showSignupNudge && (
          <View style={s.signupNudge}>
            <TouchableOpacity style={s.signupNudgeClose} onPress={() => setShowSignupNudge(false)} accessibilityLabel="닫기">
              <CancelIcon size={13} color={TEXT_MUTED} />
            </TouchableOpacity>
            <IconLabel Icon={ParticipantAcceptIcon} size={s.signupNudgeTitle.fontSize || 14} color={s.signupNudgeTitle.color} textStyle={s.signupNudgeTitle}>
              가입을 환영해요!
            </IconLabel>
            <Text style={s.signupNudgeSub}>같이 방탈출 갈 사람을 구하는{'\n'}모집 게시판부터 둘러보실래요?</Text>
            <GradientButton
              label="모집 게시판 보러가기 →"
              onPress={() => { setShowSignupNudge(false); navigation.navigate('Recruit'); }}
              style={s.signupNudgeBtn}
            />
            {/* 80차 계속: [발견성 개선, fork 감사로 발견] 친구초대(초대 200P/가입 100P)가
                MyPage 메뉴 깊숙이만 있어 이 온보딩 배너에서 아예 발견 못 하고 지나칠
                수 있었음 — 주 CTA는 그대로 두고 보조 링크로 노출. */}
            <TouchableOpacity
              onPress={() => { setShowSignupNudge(false); navigation.navigate('InviteFriend'); }}
              style={s.signupNudgeInviteRow}>
              <RewardIcon size={12} color={GOLD} />
              <Text style={s.signupNudgeInviteTxt}>친구 초대하면 200P 받기 →</Text>
            </TouchableOpacity>
          </View>
        )}

        {/* ── 비로그인 유도 배너 ──────────────────────────── */}
        {!isLoggedIn && (
          <TouchableOpacity style={s.guestBanner} onPress={() => navigation.navigate('Login')} activeOpacity={0.88}>
            <View style={s.guestBannerLeft}>
              <Text style={s.guestBannerTitle}>로그인하고 더 많은 기능을</Text>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
                {[
                  { Icon: MenuReservationIcon, label: '예약 관리' },
                  { Icon: PeopleIcon,          label: '팀 모집' },
                  { Icon: MenuReviewIcon,      label: '리뷰 작성' },
                  { Icon: RewardIcon,          label: '포인트 적립' },
                ].map(({ Icon, label }) => (
                  <View key={label} style={[s.guestBannerChip, { flexDirection: 'row', alignItems: 'center', gap: 4 }]}>
                    <Icon size={11} color={GOLD} />
                    <Text style={s.guestBannerChipTxt}>{label}</Text>
                  </View>
                ))}
              </View>
            </View>
            <View style={s.guestBannerArrow}>
              <Text style={{ color: GOLD, fontSize: 20, fontWeight: '800' }}>→</Text>
            </View>
          </TouchableOpacity>
        )}

        {/* ── 다가오는 예약 퀵뷰 ──────────────────────────── */}
        {isLoggedIn && upcomingReservations.length > 0 && (
          <View style={s.section}>
            <SectionHeader icon="calendar" title="다가오는 내 예약" accentColor={TEAL} onMore={() => navigation.navigate('ReservationHistory')} />
            <FlatList
              data={upcomingReservations}
              keyExtractor={i => i.id}
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{ paddingLeft: 16, paddingRight: 16 }}
              renderItem={({ item }) => (
                <UpcomingReservationCard reservation={item} onPress={() => navigation.navigate('ReservationHistory')} />
              )}
            />
          </View>
        )}

        {/* ── 성공률 기반 난이도 추천 ─────────────────────── */}
        {isLoggedIn && (
          <RecommendSection allProducts={allProducts} userRecords={userReservations} navigation={navigation} />
        )}

        {/* ── ① 시즌 이벤트 ───────────────────────────────── */}
        {/* 78차 38차: 진행 중인 시즌 이벤트가 없으면 "없습니다" 안내만 있는 빈 섹션을 보여주는
            대신 "월간 인기 Top"(아래 ②)과 동일하게 섹션 자체를 숨김 — 로딩 중엔 스켈레톤을
            보여줘야 하니 loading 중에는 계속 노출 */}
        {(loading || seasonalProducts.length > 0) && (
          <View style={s.section}>
            <SectionHeader icon="gift" title="지금 주목할 시즌 이벤트" accentColor={ORANGE} onMore={goBooking} />
            {renderEventBanners()}
          </View>
        )}

        {/* ── ② 월간 인기 Top ─────────────────────────────── */}
        {/* 75차: 지난달 예약수 집계가 없으면(신규 서비스라 아직 데이터가 없는 등) 섹션
            자체를 숨김 — 집계 없이 "Top 5"라는 라벨만 보이는 게 더 이상함 */}
        {popularThemes.length > 0 && (
          <View style={s.section}>
            <SectionHeader icon="trophy" title="이달의 인기 테마 Top 5" accentColor={GOLD} onMore={goRanking}
              moreLabel="랭킹 보기" moreIcon={TrophyIcon} emphasis />
            <PaginatedHorizontalList data={popularThemes} loading={loading} onMore={goRanking} onPressItem={goDetail} />
          </View>
        )}

        {/* ── ③ 리뷰 검증 테마 ─────────────────────────────── */}
        {reviewVerifiedThemes.length > 0 && (
          <View style={s.section}>
            <SectionHeader icon="chatbubbles" title="리뷰로 검증된 테마" accentColor={BLUE} onMore={goBooking} />
            <PaginatedHorizontalList data={reviewVerifiedThemes} loading={loading} onMore={goBooking} onPressItem={goDetail} />
          </View>
        )}

        {/* ── ④ 고난이도 도전 ─────────────────────────────── */}
        {expertThemes.length > 0 && (
          <View style={s.section}>
            <SectionHeader icon="skull" title="고수만 도전하는 난이도" accentColor={RED} onMore={goBooking} />
            <PaginatedHorizontalList data={expertThemes} loading={loading} onMore={goBooking} onPressItem={goDetail} />
          </View>
        )}

        {/* 77차: 인기/리뷰검증/고난이도 셋 다 집계 데이터(지난달 예약수·리뷰) 기준이라,
            신규 서비스처럼 예약·리뷰가 아직 없으면 위 세 섹션이 전부 동시에 숨겨져서
            홈 화면이 시즌 이벤트 아래로 통째로 텅 비어 보이는 문제(비회원도 로그인 유저도
            동일하게 발생 — "테마가 없다"가 아니라 세 섹션의 노출 조건을 전부 못 채운 것)를
            수정. 이미 로드해둔 allProducts로 별도 조회 없이, 위 세 섹션이 전부 비었을 때만
            폴백으로 "전체 테마"를 보여줌(있으면 굳이 중복 노출 안 함). */}
        {!loading && popularThemes.length === 0 && reviewVerifiedThemes.length === 0 && expertThemes.length === 0 && allProducts.length > 0 && (
          <View style={s.section}>
            <SectionHeader icon="albums" title="전체 테마" accentColor={GOLD} onMore={goBooking} />
            <PaginatedHorizontalList data={allProducts.slice(0, 10)} loading={loading} onMore={goBooking} onPressItem={goDetail} />
          </View>
        )}

        {/* ── 매장 0곳(진짜 빈 상태) — 오픈 초기에 입점 매장이 아직 없을 수 있는
            시나리오. 위 세 섹션+폴백이 전부 allProducts.length에 의존하다 보니 정말
            0곳이면 이 자리가 통째로 빈 채로 남아 로그인 유저는(비로그인 전용인 아래
            모집 배너도 못 봐서) 갈 곳이 없어짐 — "매장 모집이 안 됐다"는 실패 인정
            대신 담백한 준비중 문구로, 그리고 지금 사업 전략(모집탭 중심 유저 확보)과
            직접 연결되도록 모집 게시판 CTA를 명시적으로 둠. */}
        {!loading && allProducts.length === 0 && (
          <View style={s.emptyStoresBlock}>
            <EmptyStoresIcon size={64} />
            <Text style={s.emptyStoresTitle}>새로운 매장을 준비하고 있어요</Text>
            <Text style={s.emptyStoresSub}>매장이 열리기 전에도{'\n'}모집 게시판에서 같이 갈 사람을 먼저 구해보세요</Text>
            <GradientButton label="모집 게시판 보러가기 →" onPress={() => navigation.navigate('Recruit')} style={s.emptyStoresBtn} />
          </View>
        )}

        {/* ── 비로그인 모집 배너 ──────────────────────────── */}
        {/* 80차 계속: allProducts.length===0이면 바로 위 "매장 준비중" 블록이 이미
            동일한 모집 게시판 CTA를 보여주므로, 여기서 또 겹쳐 보이지 않게 제외. */}
        {!isLoggedIn && allProducts.length > 0 && (
          <TouchableOpacity style={s.recruitBanner} onPress={() => navigation.navigate('Recruit')}>
            <View>
              <IconLabel Icon={ParticipantAcceptIcon} size={s.recruitTitle.fontSize || 15} color={s.recruitTitle.color} textStyle={s.recruitTitle}>같이 탈출할 팀원을 찾고 있나요?</IconLabel>
              <Text style={s.recruitSub}>인원 모집 게시판에서 팀을 구해보세요</Text>
            </View>
            <Text style={s.recruitArrow}>›</Text>
          </TouchableOpacity>
        )}

        {/* ── 푸터 ────────────────────────────────────────── */}
        <View style={s.footer}>
          <View style={s.footerBorder} />
          <Text style={s.footerLogo}>UNLOCK</Text>
          <View style={s.footerLinks}>
            {[
              { label: '이용약관', onPress: () => navigation.navigate('Terms') },
              { label: '개인정보처리방침', onPress: () => navigation.navigate('Privacy') },
              { label: '문의', onPress: () => {
                if (!isLoggedIn) {
                  showAlert('로그인 필요', '문의하기는 로그인 후 이용 가능합니다.', [
                    { text: '취소', style: 'cancel' },
                    { text: '로그인하기', onPress: () => navigation.navigate('Login') },
                  ]);
                  return;
                }
                navigation.navigate('WriteInquiry', { targetType: 'app' });
              } },
              // 80차 계속: 매장 제휴 문의 — 매장이 0곳인 지금도, 나중에 몇 곳이 생겨도
              // 계속 유효한 CTA라 상시 노출되는 푸터에 배치(빈 상태 블록에만 두면 매장이
              // 생기는 순간 문의 창구가 같이 사라져서). 기존 "문의"와 동일한 창구
              // (WriteInquiry, targetType:'app')를 재사용 — 별도 인프라 불필요.
              { label: '매장 제휴 문의', onPress: () => {
                if (!isLoggedIn) {
                  showAlert('로그인 필요', '제휴 문의는 로그인 후 이용 가능합니다.', [
                    { text: '취소', style: 'cancel' },
                    { text: '로그인하기', onPress: () => navigation.navigate('Login') },
                  ]);
                  return;
                }
                navigation.navigate('WriteInquiry', { targetType: 'app' });
              } },
            ].map((item, i) => (
              <React.Fragment key={item.label}>
                {i > 0 && <Text style={s.footerDot}> · </Text>}
                <TouchableOpacity onPress={item.onPress}>
                  <Text style={s.footerLink}>{item.label}</Text>
                </TouchableOpacity>
              </React.Fragment>
            ))}
          </View>
          <Text style={s.footerCopy}>© 2026 UNLOCK. All rights reserved.</Text>
        </View>
      </ScrollView>
    </View>
  );
}

const s = StyleSheet.create({
  container:          { flex: 1, backgroundColor: BG },
  greetingText:       { color: GOLD, fontSize: 13, fontWeight: '700' },

  hero:               { marginHorizontal: 16, marginTop: 14, marginBottom: 24, backgroundColor: SURFACE, borderRadius: RADIUS.lg, padding: 20, borderWidth: 1, borderColor: BORDER },
  heroLeft:           { marginBottom: 16 },
  heroEyebrow:        { fontSize: 11, color: GOLD, fontWeight: '600', letterSpacing: 1.5, marginBottom: 8, opacity: 0.85 },
  heroTitle:          { fontSize: 22, fontWeight: '900', color: TEXT, lineHeight: 30 },
  heroHighlight:      { color: GOLD },
  heroStats:          { flexDirection: 'row', alignItems: 'center', marginBottom: 16 },
  heroStat:           { flex: 1, alignItems: 'center' },
  heroStatValue:      { fontSize: 20, fontWeight: '800', color: GOLD, lineHeight: 24 },
  heroStatLabel:      { fontSize: 10, color: TEXT_MUTED, marginTop: 3 },
  heroStatDivider:    { width: 1, height: 28, backgroundColor: BORDER },
  heroBtnRow:         { flexDirection: 'row', gap: 10, alignItems: 'stretch' },
  // 72차: 기본 CTA는 GradientButton 컴포넌트로 교체 — 위 2개 스타일은 삭제됨
  heroBtnSecondary:   { flex: 1, height: 46 },
  heroBtnSecondaryText: { fontSize: 13 },

  guestBanner:        { marginHorizontal: 16, marginBottom: 20, backgroundColor: SURFACE, borderRadius: RADIUS.md, padding: 16, borderWidth: 1.5, borderColor: 'rgba(212,168,67,0.3)', flexDirection: 'row', alignItems: 'center', gap: 12 },
  guestBannerLeft:    { flex: 1 },
  guestBannerTitle:   { color: TEXT, fontSize: 14, fontWeight: '800' },
  guestBannerChip:    { backgroundColor: 'rgba(212,168,67,0.1)', borderRadius: 8, paddingHorizontal: 8, paddingVertical: 4, borderWidth: 1, borderColor: 'rgba(212,168,67,0.2)' },
  guestBannerChipTxt: { color: GOLD, fontSize: 11, fontWeight: '600' },
  guestBannerArrow:   { width: 36, height: 36, borderRadius: RADIUS.pill, backgroundColor: 'rgba(212,168,67,0.1)', alignItems: 'center', justifyContent: 'center' },

  section:            { marginBottom: 32 },

  emptyEvent:         { marginHorizontal: 16, backgroundColor: SURFACE, borderRadius: RADIUS.md, padding: 20, borderWidth: 1, borderColor: 'rgba(255,107,53,0.15)', alignItems: 'center' },
  emptyEventText:     { color: TEXT_MUTED, fontSize: 13, fontStyle: 'italic' },

  recruitBanner:      { marginHorizontal: 16, marginBottom: 24, backgroundColor: GOLD + '15', borderRadius: RADIUS.md, padding: 18, borderWidth: 1, borderColor: GOLD + '30', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  // 80차 계속: 가입 직후 1회 노출되는 모집탭 유도 배너
  signupNudge:        { marginHorizontal: 16, marginTop: 16, marginBottom: 8, backgroundColor: GOLD + '15', borderRadius: RADIUS.md, padding: 18, borderWidth: 1, borderColor: GOLD + '30' },
  signupNudgeClose:   { position: 'absolute', top: 12, right: 12, padding: 4, zIndex: 1 },
  signupNudgeTitle:   { color: TEXT, fontSize: 14, fontWeight: '800', marginBottom: 6 },
  signupNudgeSub:     { color: TEXT_SEC, fontSize: 12, lineHeight: 18, marginBottom: 14 },
  signupNudgeBtn:     { paddingHorizontal: 20 },
  signupNudgeInviteRow: { flexDirection: 'row', alignItems: 'center', gap: 5, justifyContent: 'center', marginTop: 10 },
  signupNudgeInviteTxt: { color: GOLD, fontSize: 12, fontWeight: '700' },
  // 80차 계속: 매장 0곳(진짜 빈 상태) 안내 카드
  emptyStoresBlock:   { alignItems: 'center', marginHorizontal: 16, marginBottom: 24, padding: 32, backgroundColor: SURFACE, borderRadius: RADIUS.md, borderWidth: 1, borderColor: BORDER, gap: 8 },
  emptyStoresTitle:   { color: TEXT, fontSize: 16, fontWeight: '800', marginTop: 6 },
  emptyStoresSub:     { color: TEXT_SEC, fontSize: 13, textAlign: 'center', lineHeight: 20 },
  emptyStoresBtn:     { marginTop: 10, paddingHorizontal: 20 },
  recruitTitle:       { color: TEXT, fontSize: 14, fontWeight: '800', marginBottom: 4 },
  recruitSub:         { color: TEXT_SEC, fontSize: 12 },
  recruitArrow:       { color: GOLD, fontSize: 28 },

  footer:             { marginTop: 10, paddingBottom: 20 },
  footerBorder:       { height: 1, backgroundColor: BORDER, marginHorizontal: 16, marginBottom: 20 },
  footerLogo:         { textAlign: 'center', fontSize: 16, fontWeight: '900', color: GOLD, letterSpacing: 2, marginBottom: 12 },
  footerLinks:        { flexDirection: 'row', justifyContent: 'center', marginBottom: 8 },
  footerLink:         { color: TEXT_MUTED, fontSize: 12 },
  footerDot:          { color: TEXT_MUTED, fontSize: 12 },
  footerCopy:         { textAlign: 'center', color: TEXT_MUTED, fontSize: 11 },
});